<template>
  <div class="column content-box full_page page_container">
    <!-- <woot-button
    color-scheme="success"
    class-names="button--fixed-right-top"
    icon="add-circle"
    :is-disabled="!primaryCalendar.access_token"
    @click="clearAndOpen()"
    >
      {{ $t('CALENDAR_MGMT.ADD_HEADER_BTN_TXT') }}
    </woot-button> -->
    <div class="header_right">
      <div class="notify">
        <p class="mt_4">
          {{$t('CALENDAR_MGMT.GOOGLE_CONNECT_MSG')}}
          <router-link class="font_500 " :to="profileSettingUrl">{{$t('CALENDAR_MGMT.GOOGLE_CONNECT_LINK')}}</router-link>
        </p>
      </div>
      <woot-button
        color-scheme="primary"
        icon="add-circle"
        :is-disabled="!primaryCalendar.access_token"
        @click="clearAndOpen()"
        >
          {{ $t('CALENDAR_MGMT.ADD_HEADER_BTN_TXT') }}
        </woot-button>
    </div>

    <!-- <session-header header-title="Meeting Sessions" /> -->

    <sessions-table :sessions="sessions" :refresh="getSessions" :is-loading="isFetchingSessions"
      :currentUserId="currentUserId" :openSessionEditor="openSessionEditor" />
    <woot-modal :show.sync="showAddPopup" size="medium" :on-close="hideAddPopup">
      <CalendarMeetingAdd :on-close="hideAddPopup" :refresh="getSessions" :currentUserId="currentUserId"
        :prefilledForm="prefilledForm" />
    </woot-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import CalendarMeetingAdd from './CalendarMeetingAdd.vue';
import SessionsTable from './SessionsTable.vue';
import CalendarApi from '../../../api/calendar';
import { popupHelpers } from '../../../helper/demoAutomationHelper';

export default {
  name: 'calendarView',
  computed: {
    ...mapGetters({
      globalConfig: 'globalConfig/get',
      currentUserId: 'getCurrentUserID',
      currentUser: 'getCurrentUser',
    }),
    profileSettingUrl(){
      return `/app/accounts/${this.currentUser.account_id}/profile/settings`;
    },
  },
  data() {
    return {
      loading: {},
      showAddPopup: false,
      sessions: [],
      isFetchingSessions: false,
      prefilledForm: null,
      primaryCalendar: {}
    };
  },
  async mounted() {
    this.getSessions();
    this.getCalendar();
    // ----------------------------------
    bus.$on('instruct_demo_meeting_event', (data) => {
      const {instructSchedule} = data;
      console.log('instruct_demo_meeting_event in Google Sk',instructSchedule);
      // this.showAddPopup = true;
      // open a new url for the schedule link
      const appointment_url = `https://schedule.peasy.ai/book/user/${this.currentUserId}/${instructSchedule.unique_link}`;
      popupHelpers.openNewTab(appointment_url);

      this.getSessions();
      this.openSessionEditor(instructSchedule);
    });
    // ----------------------------------
  },
  methods: {
    clearAndOpen() {
      this.prefilledForm = null;
      this.openAddPopup();
    },
    openSessionEditor(sessionData) {
      console.log(sessionData,'sessionData match with instructSchedule');
      const preparedObject = {
        meetingTitle: sessionData.title,
        meetingDescription: sessionData.description,
        duration: sessionData.duration,
        business_hours: sessionData.availability,
        maximumMeeting: sessionData.max_meetings,
        maximumBufferTime: sessionData.buffer_time,
        noticeTime: sessionData.notice_time,
        reminder_time: sessionData.reminder_time,
        confirmation_msg: sessionData.confirmation_msg,
        reminder_msg: sessionData.reminder_msg,
        cancelled_msg: sessionData.cancelled_msg || { template_name: '', message: '' },
        inbox_id: sessionData.inbox_id,
        meetingLink: sessionData.unique_link,
        location: sessionData.location,
        color: sessionData.color,
        slots: sessionData.slots,

        meetingUniqueLink: '-',
        timezone: sessionData.timezone,
        // conference_type: 'google_meet',
        notice_time: sessionData.notice_time,
        id: sessionData.id,
        duration_type: {type: sessionData.duration_type},
      };
      this.prefilledForm = preparedObject;
      console.log('checker sessionData', sessionData, this.prefilledForm);
      this.openAddPopup();
    },
    async getSessions() {
      try {
        this.isFetchingSessions = true;
        let meetingSessions = await CalendarApi.getAllMeetingSessions();
        if (meetingSessions.data) {
          console.log('sessions94 ', meetingSessions.data);
          this.sessions = meetingSessions.data;
        }
      } catch (error) {
        console.log('error', error);
      } finally {
        this.isFetchingSessions = false;
      }
    },
    openAddPopup() {
      console.log('==========opening popup to add calendar session =======');
      this.showAddPopup = true;
    },
    hideAddPopup() {
      this.showAddPopup = false;
    },
    async getCalendar(){
      try {

        let getCalendarResponse = await CalendarApi.getCalendar();
        if (getCalendarResponse?.data) {
          this.prevCalendar = getCalendarResponse?.data;
          if (getCalendarResponse?.data?.enabled === true) {
            this.primaryCalendar = getCalendarResponse.data;
          }
        }

      } catch (error) {
        console.log(error);
      }
    },
  },
  components: { CalendarMeetingAdd, SessionsTable },
};
</script>

<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_fonts.scss';
@import '~dashboard/assets/scss/woot';

.header_right{
  position: relative;
    right: 0.8rem;
    top: 0.8rem;
    // background-color: #8D25F6 !important;
    display: flex;
    gap: 12px;
    @include breakpoint(medium up) {
      position: absolute;
      top: 0.8rem;
    }
    @include breakpoint(large up) {
      top: 0.8rem;
    }
    @include breakpoint(xlarge up) {
      top: 6.8rem;
    }

    .notify{
      max-width: 300px;
    }
}
</style>